export default __webpack_public_path__ + "static/media/SndLowerZSlideDown.a6f5caa4.mp3";